import {memo} from 'react'
import {X} from 'lucide-react'
import type {ReceivedChatMessage} from '@livekit/components-react'
import {cn} from '@/shared/lib/cn'
import {ChatMessageList} from './ChatMessageList'
import {ChatInput} from './ChatInput'

interface ChatSidebarProps {
  messages: ReceivedChatMessage[]
  onSend: (message: string) => Promise<unknown>
  isSending: boolean
  onClose: () => void
  isOpen?: boolean
  /** When true, sidebar slides in from the right (used inside animated wrapper) */
  slideFromRight?: boolean
  className?: string
}

export const ChatSidebar = memo(function ChatSidebar({
  messages,
  onSend,
  isSending,
  onClose,
  isOpen = true,
  slideFromRight = false,
  className,
}: ChatSidebarProps) {
  return (
    <div
      className={cn(
        'flex flex-col bg-card overflow-hidden',
        slideFromRight && 'transition-transform duration-300 ease-out',
        slideFromRight && (isOpen ? 'translate-x-0' : 'translate-x-full'),
        className,
      )}
    >
      <div className="flex items-center justify-between px-4 py-3 border-b border-secondary shrink-0">
        <span className="text-sm font-semibold text-foreground">Чат</span>
        <button
          onClick={onClose}
          aria-label="Закрыть чат"
          title="Закрыть чат"
          className="size-7 rounded-md flex items-center justify-center text-muted-foreground hover:text-foreground hover:bg-foreground/10 transition-colors [&_svg]:size-4 cursor-pointer"
        >
          <X />
        </button>
      </div>
      <ChatMessageList messages={messages} />
      <ChatInput onSend={onSend} isSending={isSending} />
    </div>
  )
})
